import * as React from 'react'
import MyComponentTypes from '../MyComponent/Types'
const MyLoadingHelpers = {
  addTypes(key: string, fnUI: any) {
    MyComponentTypes.addTypesGeneric(MyLoadingHelpers.Types, key, fnUI)
  },
  addTypesFromListLazy(listWithKey: any) {
    MyComponentTypes.addTypesGenericFromListLazy(
      MyLoadingHelpers.Types,
      listWithKey
    )
  },
  addTypesFromListWithoutLazy(listWithKey: any) {
    MyComponentTypes.addTypesGenericFromListWithoutLazy(
      MyLoadingHelpers.Types,
      listWithKey
    )
  },
  Types: {
    _empty: MyComponentTypes.Types._empty,
    _default: (props: any) => {
      return (
        <i
          key='iconloading'
          className={`fa fa-spinner fa-spin ${
            props.className != null ? props.className : ''
          }`}
          style={props.style}
        />
      )
    },
    _defaultlazy: (props: any) => {
      return (
        <div>
          <i
            key='iconloading'
            className={`fa fa-spinner fa-spin ${
              props.className != null ? props.className : ''
            }`}
            style={props.style}
          />
        </div>
      )
    }
  }
}

export default MyLoadingHelpers
